export default __webpack_public_path__ + "static/media/record_empty.137397ac.png";